// extracted by mini-css-extract-plugin
module.exports = {"nav":"social-network-nav-module--nav--35KIM"};